const ToggleSwitch = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onChange}
    className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 ${
      checked ? "bg-green-500" : "bg-gray-300"
    } ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
  >
    <span
      className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${
        checked ? "translate-x-8" : "translate-x-1"
      }`}
    />
  </button>
);
export default ToggleSwitch;
